import { render, staticRenderFns } from "./AdminDetails.vue?vue&type=template&id=488d2467&scoped=true"
import script from "./AdminDetails.vue?vue&type=script&lang=js"
export * from "./AdminDetails.vue?vue&type=script&lang=js"
import style0 from "./AdminDetails.vue?vue&type=style&index=0&id=488d2467&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488d2467",
  null
  
)

export default component.exports